import React, {useState} from "react";
import {useYoutubeList} from "../hooks/useYoutube";
import {ErrorAlert, Footer, Header, Loading, Pagination} from "../components";
import VideoNav from "../components/VideoNav";

const Youtube = () => {
    const [pageNumber, setPageNumber] = useState(0);
    const pageSize = 6;

    const {
        data: youtubeListData,
        isLoading: isYoutubeListLoading,
        isError: isYoutubeListError
    } = useYoutubeList(pageNumber, pageSize);

    const youtubeList = youtubeListData?.content || [];
    const totalPages = youtubeListData?.totalPages || 0;

    return (
        <div>
            <Header/>
            <div className="wrapper">
                <div className="container">
                    <VideoNav/>
                    <div className="tab-content">
                        <div className="mainInfo">
                            <div className="youtubeList">
                                <div className="row">
                                    {isYoutubeListLoading && <Loading/>}
                                    {isYoutubeListError && <ErrorAlert message={"查詢領域類型異常"}/>}
                                    {!isYoutubeListLoading && youtubeList?.map((youtubeData, index) => (
                                            <div className="col-12 col-md-6 col-lg-4" key={youtubeData.id}>
                                                <figure className="card card_vv card_yt">
                                                    <div className="card_video">
                                                        <iframe
                                                            src={youtubeData.youtubeLink}
                                                            title={youtubeData.title} frameBorder="0"
                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                            referrerPolicy="strict-origin-when-cross-origin"
                                                            allowFullScreen>
                                                        </iframe>
                                                    </div>
                                                    <div className="card-body">
                                                        <h5 className="card-title">{youtubeData.title}</h5>
                                                    </div>
                                                </figure>
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                            <Pagination
                                currentPage={pageNumber}
                                totalPages={totalPages}
                                onPageChange={(newPage) => setPageNumber(newPage)}
                                isLoading={isYoutubeListLoading}
                                isError={isYoutubeListError}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
}

export default Youtube;